// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"be1f48e6","249":"6997bab3","396":"e0240847","494":"97e6d1e0","553":"cfaded06","655":"493e975e"}[chunkId] + ".chunk.css";
};